import { ProductInterface } from '../Model/Product';
import { AbstractFilter } from './AbstractFilter';
import { FilterInterface } from './FilterInterface';

export type OneOfFilterValueType = (string | number)[];

export class OneOfFilter<T extends OneOfFilterValueType = OneOfFilterValueType> extends AbstractFilter<T> {
    get isActive(): boolean {
        return this._isActive && this.value && this.value.length > 0;
    }

    public matches(product: ProductInterface): boolean {
        const keyPath = this.keyPath;

        return undefined !== this.value.find(currentValue => this.productMatches(product, keyPath, currentValue));
    }

    protected clone(): FilterInterface<T> {
        return new OneOfFilter(this.keyPath, this.value, this.type, this.isActive);
    }
}
